<template>
  <div class="attaUpload">
    <div class="upload" v-if="!isRole">
      <div class="sel">
        <Poptip trigger="hover" word-wrap width="400" content="" transfer>
          <Icon class="icon" type="ios-alert-outline" />
          <!-- 店铺装修设计时 -->
          <div slot="content" v-if="tableName == 'CL_C_VI_BASIC_COMMIT'">
            <p>各节点必传附件说明：</p>
            <p style="line-height:1.5;">【基础资料提交】：店铺设计申请登记表、测场CAD标准文件、店铺勘查照片、签字版楼层落位图；</p>
            <p>【平面图设计】：平面图终稿；</p>
            <p>【成套图设计】：成套图终稿、灯位图；</p>
            <p>【装修预算-空调】：装修预算表-空调；</p>
            <p>【预算审核-空调】：装修预算表-空调-确认版；</p>
            <p>【装修预算-安防】：装修预算表-安防；</p>
            <p>【预算审核-安防】：装修预算表-安防-确认版；</p>
            <p>【装修预算-消防】：装修预算表-消防；</p>
            <p>【预算审核-消防】：装修预算表-消防-确认版；</p>
            <p style="line-height:1.5;">【装修预算-基装】：装修预算表-基装、新建隔墙图-基装、商场装修材料要求-基装；</p>
            <p>【预算审核-基装】：装修预算表-基装-确认版；</p>
            <p>【配货单确认】：道具配货单、灯具配货单；</p>
            <p>【供应商分配(选填)】：道具配货单-修订版、灯具配货单-修订版；</p>
            <p>【省区验收】：验收照片、验收单；</p>
          </div>
          <div slot="content" v-else>
            <p>各节点必传附件说明：</p>
            <p>基础资料提交：店铺设计申请登记表、测场CAD标准文件、店铺勘查照片、签字版楼层落位图；</p>
            <p>平面图设计：平面图终稿、灯位图、道具配货单、灯具配货单；</p>
            <p>成套图设计：成套图终稿；</p>
            <p>装修施工：施工/效果图、装修预算表、装修变更单；</p>
            <p>省区验收：验收报告、验收单、决算单；</p>
          </div>
        </Poptip>
        <label>附件上传项 :&nbsp;</label>
        <Select v-model="selectData" transfer clearable>
          <Option v-for="(item , index) in uploadItem" :key="index" :value="item.limitval">{{item.limitdesc}}</Option>
        </Select>
      </div>
      <div class="upl" v-if="uplShow">
        <label>附件上传 :&nbsp;</label>
        <Upload multiple action="/p/cs/batchUpload" name="files" :accept="acceptFile" :on-success="onSuccess" :on-error="onError" :on-remove="onRemove" :data="uplData">
          <span class="uplFile">
            <Icon type="md-cloud-upload" />上传附件
          </span>
        </Upload>
      </div>
    </div>
    <div class="pageNation" v-if="!isRole">
      <Page :total="page.total" show-sizer :page-size-opts="page.pageSizeOpts" :current="page.current" :page-size="page.pageSize" @on-change="pageChange" @on-page-size-change="pageSizeChange" />
      <div class="button" v-if="button_show">
        <span @click="save({detail:{a:'不能为空',b:2}})">【保存】</span>
        <span @click="delItem">【删除明细】</span>
        <!-- <span>【导入】</span>
        <span @click="exportFile">【导出】</span>-->
      </div>
    </div>
    <div class="table">
      <Table :columns="tableConfig.columns" :data="tableConfig.data" @on-selection-change="onSelectChange"></Table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import uploadDalog from './uploadDalog';
Vue.component('uploadDalog', uploadDalog);
const {
  network,
  urlSearchParams
} = R3;
console.log(urlSearchParams);
console.log(network);
export default {
  name: 'attaUpload',
  data() {
    return {
      tableName: '',
      button_show: true,
      uplShow: true,
      isRole:false,
      page: {
        total: 1,
        start: 0,
        current: 1,
        pageSize: 10,
        pageSizeOpts: [1, 10, 20, 30, 50]
      },
      acceptFile: '.dwg,.xls,.pptx,.jpg,.pdf,.xlsx,.ppt,.msg,.doc,.png,.docx,.txt,.rar,.dxf,.dwl,.zip,.mp4,.eml,.bmp,.jpeg,.et,.rtf,.jfif,.xlsb,.pub,.exb,.webp,.tif,.csv',
      uploadItem: [],
      files: [],
      selectData: '',
      uplData: {
        path: ''
      },
      tableConfig: {
        columns: [],
        data: [

        ]
      },
      onSelectChangeData: []
    }
  },
  created() {
    this.initData();
    window.addEventListener('customizeClick', this.save);
  },
  activated() {
    //this.refresh();
  },
  destroyed() {
    window.removeEventListener('customizeClick', this.save);
  },
  methods: {
    refresh() {  //刷新
      this.initData();
      this.getTableData();
      this.selectData = undefined;
      this.uplShow = false;
      this.$nextTick(() => {
        this.uplShow = true;
        this.files = [];
        this.onSelectChangeData = []
      })
    },
    initData() {
      let self = this;
      const { tableName } = this.$router.currentRoute.params;
      // console.log('tableName :>> ', tableName);
      this.tableName = tableName
      axios({
        url: '/p/cs/checkButtonIsHide',
        method: 'post',
        data: { objid: this.$route.params.itemId }
      }).then(res => {
        if (res.data.code == 0) {
          this.button_show = res.data.flag;
        } else {
          this.$Message.error(res.data.message);
        }
      });

      let formdata = new FormData();
      this.uplData.path = `${this.$route.params.tableName}/${this.$route.params.itemId}/${new Date().getTime()}/`
      formdata.append('table', 'CL_C_VI_DESIGN_COMMIT');
      formdata.append('inlinemode', 'Y')
      axios({
        url: '/p/cs/inputForitem',
        method: 'post',
        data: formdata
      }).then(res => {
        if (res.data.code == 0) {
          this.uploadItem = res.data.data.inpubobj.filter(item => item.colname == "UPLOAD_ITEM")[0].combobox;
          axios({
            url:'/p/cs/getRoleInfo',
            method:'post',
            data:{userId:this.$store.state.global.userInfo.id}
          }).then(_res =>{
            if(_res.data.code == 0 && _res.data.data && _res.data.data.length > 0){
              let _uploadItem = [];
              let _isRole = false;
              _res.data.data.forEach(function(item){
                if(item.roleName == "货架供应商" || item.roleName == "货架供应商" || item.roleName == "货架供应商" || item.roleName == "货架供应商"){
                  res.data.data.inpubobj.filter(item => item.colname == "UPLOAD_ITEM")[0].combobox.forEach(function(_item){
                    if(_item.limitval == "20" || _item.limitval == "21"){
                      _uploadItem.push(_item);
                    }
                    _isRole = true;
                  });
                  self.uploadItem = _uploadItem;
                  return;
                }
              });
              if(_isRole){
                self.page.pageSize = 100;
                self.isRole = true;
                // $(".ark-tabs-panels-tab")[1].remove();
              }else{
                self.isRole = false;
              }
            }
            self.getTableData();
          })
        }
      });
    },
    getTableData() {
      this.tableConfig.columns = [];
      let obj = {};
      obj['startindex'] = this.page.pageSize * (this.page.current - 1);
      obj['range'] = this.page.pageSize;
      obj['column_include_uicontroller'] = true;
      let formdata = new FormData();
      formdata.append('table', 'CL_C_VI_DESIGN_COMMIT');
      formdata.append('objid', this.$route.params.itemId);
      formdata.append('refcolid', 1700841239);
      formdata.append('searchdata', JSON.stringify(obj));
      axios({
        url: '/p/cs/objectTableItem',
        method: 'post',
        data: formdata
      }).then(res => {
        if (res.data.code == 0) {
          let arr = [];
          res.data.datas.tabth.forEach(item => {
            if (item.colname !== 'ID') {
              let obj = {};
              obj['title'] = item.name;
              obj['key'] = item.colname
              arr.push(obj);
            } else {
              let obj = {};
              obj['type'] = 'selection';
              obj['name'] = item.name;
              obj['colname'] = item.colname
              arr.push(obj);
            }
          });
          let _details = [];
          if(this.isRole){
            // 供应商待办 附件单独处理
            let UPLOAD_ITEM_ARR = []
            if(this.tableName == "CL_C_VI_BASIC_COMMIT"){
              UPLOAD_ITEM_ARR = ['道具配货单-修订版', '灯具配货单-修订版', '平面图终稿']
            } else {
              UPLOAD_ITEM_ARR = ['道具配货单-修订版', '灯具配货单-修订版', '道具配货单', '灯具配货单', '平面图终稿']
            }
            res.data.datas.row.forEach(item=>{
              if(UPLOAD_ITEM_ARR.includes(item.UPLOAD_ITEM.val)){
                _details.push(item);
              }
            });
            res.data.datas.row = _details;
          }
          this.page.total = res.data.datas.totalRowCount; //总条数
          this.page.start = res.data.datas.start; //开始条数
          this.page.pageSize = res.data.datas.defaultrange; //每页条数
          this.page.pageSizeOpts = res.data.datas.selectrange;
          this.tableConfig.columns = arr
          this.renderColumn(this.tableConfig.columns);
          this.tableConfig.data = res.data.datas.row.map(item => {
            let obj = {};
            for (let key in item) {
              obj[key] = item[key].val;
            }
            return obj;
          });
        }
      })
    },
    onSuccess(res, file, filelist) {
      if (res.code == 0) {
        this.files = filelist;
        let data = '';
        let formdata = new FormData();
        data = this.files.map(res => {
          return res.response.data[0].UploadId;
        });
        formdata.append('uploadIds', data.join(','));
        axios({
          url: '/p/cs/batchUploadProgress',
          method: 'post',
          data: formdata
        }).then(res => {
        })
      } else {
        this.$Message.warning(res.message);
      }
    },
    onError(e) {
      this.$Message.warning(e.message);
    },
    onRemove(res, filelist) {
      this.files = filelist;
    },
    save(e) {
      console.log("save.e=>", e);
      if (e.detail.type == 'refresh') {
        this.refresh();
      }
      if (Object.keys(e.detail).length <= 1 && e.detail.type !== 'save') return;
      if (!this.selectData && this.files.length == 0) return;
      if (!this.selectData || this.files.length == 0) {
        this.$Message.warning('附件上传项与附件上传不能为空!');
        return;
      }
      let self = this;
      let data = {};
      let arr = this.files.map(item => {
        let obj = {};
        obj['name'] = item.response.data[0].Name;
        obj['url'] = item.response.data[0].Url;
        obj['Size'] = item.response.data[0].Size;
        return obj;
      });
      data['CL_C_VI_DESIGN_COMMIT'] = [{}];
      data['CL_C_VI_DESIGN_COMMIT'][0]['UPLOAD_ITEM'] = this.selectData;
      data['CL_C_VI_DESIGN_COMMIT'][0]['TYPE'] = JSON.stringify(arr);
      data['CL_C_VI_DESIGN_COMMIT'][0]['ID'] = -1;
      R3.network.post('/p/cs/objectSave', R3.urlSearchParams({ table: this.$route.params.tableName, objid: this.$route.params.itemId, data: data })).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          this.refresh();
        } else {
          this.$Message.error(res.data.message);
        }
      })
    },
    renderColumn(column) {
      let self = this;
      column.forEach(item => {
        if (item.key == 'TYPE') {
          item['render'] = (h, params) => {
            let str = JSON.parse(params.row.TYPE).map(item => {
              return `【${item.name}】`
            })
            return h('div', {
              style: {
                position: 'relative'
              }
            },
              [
                h('span', {
                }, str),
                h('Poptip', {
                  props: {
                    trigger: 'click',
                    transfer: true,
                    content: 'content'
                  },
                  scopedSlots: {
                    default: () => h('div', {
                      style: {
                        'padding-left': '10px',
                        'padding-right': '10px',
                      },
                      domProps: {
                        innerHTML: '<i class="iconfont iconbj_listedit" style="color: #2D8CF0; font-size: 16px"></i>'
                      },
                    }),
                    content: () => h('uploadDalog', {
                      props: {
                        uploadData: params.row
                      },
                      on: {
                        'refresh': () => {
                          this.refresh();
                        }
                      }
                    })
                  }
                })
              ])
          }
        }
      })
    },
    onSelectChange(sel) {
      this.onSelectChangeData = sel;
    },
    delItem() {
      if (this.onSelectChangeData.length == 0) {
        this.$Message.warning('请选择删除项!');
        return;
      }
      this.$Modal.fcWarning({
        title: '提示',
        content: '确认执行删除?',
        showCancel: true,
        onOk: () => {
          let obj = {};
          obj['table'] = this.$route.params.tableName;
          obj['objid'] = this.$route.params.itemId;
          obj['isdelmtable'] = 'isdelmtable';
          let data = {}
          data['CL_C_VI_DESIGN_COMMIT'] = this.onSelectChangeData.map(item => item.ID);
          obj['data'] = data;
          R3.network.post('/p/cs/storeViAnnexDelete', R3.urlSearchParams(obj)).then(res => {
            if (res.data.code == 0) {
              this.$Message.success(res.data.message);
              this.refresh();
            } else {
              this.$Message.warning(res.data.message);
            }
          })
        }
      })
    },
    exportFile() {
      let data = {};
      let obj = {};
      obj['table'] = this.$route.params.tableName;
      obj['column_include_uicontroller'] = true;
      let fixedcolumns = {};
      fixedcolumns['ID'] = this.onSelectChangeData.length == 0 ? null : this.onSelectChangeData.map(item => item.ID);
      fixedcolumns['objectIds'] = `1700841239=${this.$route.params.itemId}`
      fixedcolumns['startindex'] = this.page.pageSize * (this.page.current - 1);
      fixedcolumns['range'] = this.page.pageSize;
      obj['fixedcolumns'] = fixedcolumns;
      data['searchdata'] = obj;
      data['filename'] = '装修设计-附件上传';
      data['filetype'] = '.xlsx';
      data['showColumnName'] = true;
      data['menu'] = '装修设计-附件上传';
      R3.network.post('/p/cs/export', R3.urlSearchParams(data)).then(res => {
        console.log(res);
      })
    },
    pageChange(val) {
      this.page.current = val;
      if(!this.isRole){
        this.getTableData();
      }
    },
    pageSizeChange(val) {
      this.page.pageSize = val;
      if(!this.isRole){
        this.getTableData();
      }
    }
  }
}
</script>

<style lang="less">
.attaUpload {
  height: 500px;
  .upload {
    display: flex;
    background: #f8f8f8;
    .sel,
    .upl {
      white-space: nowrap;
      line-height: 26px;
      display: flex;
      width: 200px;
      margin-left: 50px;
      margin-top: 5px;
      margin-bottom: 5px;
      label:before {
        content: "*";
        color: red;
        margin-right: 2px;
      }
    }
    .upl {
      margin-left: 100px;
      .uplFile {
        cursor: pointer;
        color: #0f8ee9;
      }
    }
    .sel {
      .icon {
        color: red;
        font-size: 12px;
      }
    }
  }
  .pageNation {
    margin: 8px 0;
    display: flex;
    .button {
      color: #0f8ee9;
      margin-top: 9px;
      cursor: pointer;
    }
  }
}
</style>